













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  JobType,
  TradePagedCollectionApiResponse,
  TradesApi
} from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    api: 'tradesApi'
  })
})
export default class JobTypePicker extends Vue {
  private api!: TradesApi;
  private jobTypes!: JobType[];
  private pagedTrades!: TradePagedCollectionApiResponse;
  private pickedTradeId!: string;
  private loadingJobTypes = true;

  @Prop({ required: false, default: false })
  private required?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideAll?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, default: undefined })
  private tradeFilter!: string;

  @Prop({ required: false, default: undefined })
  private kindFilter!: string;

  @Prop({ required: false, default: 'Job Type' })
  private labelOverride?: string;

  get getValue() {
    return this.value;
  }

  get getValueId() {
    return this.filteredJobTypes.find((f) => f.jobTypeName === this.getValue)
      ?.jobTypeId;
  }

  private data() {
    // this lets the undefined allTrades! refs become reactive
    // https://class-component.vuejs.org/guide/class-component.html#data
    return {
      jobTypes: undefined
    };
  }

  private get sortedJobTypes() {
    return this.jobTypes.sort((a, b) => {
      return (a.sort || 0) - (b.sort || 0);
    });
  }

  private get filteredJobTypes(): JobType[] {
    if (this.tradeFilter === undefined || this.tradeFilter === 'All') {
      if (this.kindFilter) {
        // filtered by kind only
        const filteredByKind = this.sortedJobTypes.filter(
          (jobType) => jobType.kindFilter === this.kindFilter
        );
        return filteredByKind;
      } else {
        // not filtered
        return this.sortedJobTypes;
      }
    } else {
      const filteredByTrade = this.sortedJobTypes.filter(
        (jobType) => jobType.trade === this.tradeFilter
      );
      if (this.kindFilter) {
        // filtered by trade and kind
        const filteredByTradeAndKind = filteredByTrade.filter(
          (jobType) => jobType.kindFilter === this.kindFilter
        );
        return filteredByTradeAndKind;
      } else {
        // filtered by trade only
        return filteredByTrade;
      }
    }
  }

  @Watch('propertyId', { immediate: true })
  private async loadJobTypesByProperty() {
    this.loadingJobTypes = true;
    this.jobTypes = [];
    this.jobTypes = await this.api.getPropertyJobTypes({
      propertyId: this.propertyId
    });
    this.loadingJobTypes = false;
  }

  @Watch('tradeFilter')
  private onTradeFilterChange(newTrade: string, oldTrade: string) {
    if (oldTrade === undefined || oldTrade === 'All') return;
    this.$emit('input', '');
  }

  private async jobTypeChangedHandler(jobTypeInput: string) {
    var jobType = this.jobTypes.filter((j) => j.jobTypeId === jobTypeInput);
    this.$emit('input', jobType[0].jobTypeName);
    this.$emit('job-type-object-changed', jobType[0]);
  }
}
